import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { setEndDate, setStartDate } from "../../redux/slices/newApplicantsSlice";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { formatDateForDisplay } from "../../utils/HelperFunctions";

const DateRangePickerComponent = () => {
    const startDate = useSelector((state) => state.newApplicants.startDate);
    const endDate = useSelector((state) => state.newApplicants.endDate);
    const dispatch = useDispatch();

    // Function to get the start and end dates of the current week
    // const getCurrentWeekDates = () => {
    //   const currentDate = new Date();
    //   // Calculate the start date 6 months before the current date
    //   const startDate = new Date(currentDate);
    //   startDate.setMonth(startDate.getMonth() - 6);

    //   return { startDate, endDate: currentDate };
    // };

    useEffect(() => {
        // const { startDate, endDate } = getCurrentWeekDates();
        if (startDate === "Invalid date" && endDate === "Invalid date") {
            dispatch(setStartDate(null));
            dispatch(setEndDate(null));
        } else {
            // dispatch(setStartDate(moment(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")));
            // dispatch(setEndDate(moment(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")));
        }
    }, [dispatch]);

    return (
        <div
            className="center-alignment start-date"
            style={{
                borderRadius: "8px",
                border: "1px solid #C3D3E2",
                padding: "0px 5px",
                gap: "5px",
            }}
        >
            {/* Start Date */}
            <DatePicker
                className="custom-datepicker"
                value={formatDateForDisplay(startDate, "DD/MM/YYYY", "")}
                onChange={(value) => {
                    const formattedDate = new Date(value).toISOString();
                    dispatch(setStartDate(moment(formattedDate)?.format("YYYY-MM-DD")));
                }}
                headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]}
                format="DD/MM/YYYY"
                editable={false}
                placeholder="DD-MM-YYYY"
                months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
            />
            <span> - </span>
            {/* End Date */}
            <DatePicker
                className="custom-datepicker end-range-date "
                value={formatDateForDisplay(endDate, "DD/MM/YYYY", "")}
                onChange={(value) => {
                    const formattedDate = new Date(value).toISOString();
                    dispatch(setEndDate(moment(formattedDate)?.format("YYYY-MM-DD")));
                }}
                headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]}
                format="DD/MM/YYYY"
                editable={false}
                placeholder="DD-MM-YYYY"
                months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                minDate={startDate && moment(startDate).isValid() ? moment(startDate).toDate() : undefined}
            />
        </div>
    );
};

export default DateRangePickerComponent;
